import { semanticColors } from "core/styles/semanticColors";
import { colors } from "styles/colors";

/** Theme-aware chrome tokens for the editor top navigation bar. */
export const editorTopNavChrome = {
  barHeightPx: 48,
  controlHeightPx: 28,
  controlRadiusPx: 6,
  controlInnerHeightPx: 24,
  segmentedPaddingPx: 2,
  barBackground: semanticColors.background,
  barBorder: semanticColors.border,
  title: semanticColors.subtleForeground,
  titleHover: semanticColors.foreground,
  mutedText: semanticColors.mutedForeground,
  icon: semanticColors.mutedForeground,
  iconHover: semanticColors.subtleForeground,
  statusIcon: semanticColors.faintForeground,
  iconButtonHoverBg: semanticColors.accent,
  segmentedTrack: semanticColors.accentStrong,
  segmentedActive: semanticColors.card,
  segmentedBorder: semanticColors.border,
  previewBarBorder: semanticColors.border,
  previewBarButtonActiveBg: semanticColors.accentStrong,
  previewBarDarkBackground: colors.GREY_900,
  previewBarDarkBorder: colors.GREY_800,
  tabInactive: semanticColors.mutedForeground,
  tabActive: semanticColors.foreground,
  tabHoverBg: semanticColors.accent,
  tabGroupRadiusPx: 6,
  tabRadiusPx: 6,
  fullscreenShadow: "0 1px 3px rgba(32, 36, 48, 0.08)",
  logoMarkSizePx: 28,
  logoMarkRadiusPx: 6,
  logoMarkBackground: semanticColors.logoMark,
  logoIconSizePx: 22,
  previewBarLogoMarginLeftPx: 6,
  previewBarLogoSizePx: 32,
} as const;
